module.exports = __webpack_public_path__ + "img/Z82_04.78d89efa.jpg";